import wx from 'weixin-js-sdk';

let isConfiguring = false;
let currentPromise = null;

/**
 * 获取用于微信 JS-SDK 签名的当前页面 URL
 * 微信官方规范：签名用的 url 必须是调用 JS 接口页面的完整 URL，且不包含 '#' 及其后面部分。
 * iOS WKWebView 中微信校验的是页面入口 URL，需缓存首次进入时的 URL。
 */
export function getWechatSignUrl() {
  // iOS 环境下缓存入口 URL（在 SPA 单页内只取一次，避免路由切换后 url 变化导致签名不匹配）
  if (window.__wxjs_is_wkwebview) {
    if (!window.entryUrl) {
      window.entryUrl = window.location.href.split('#')[0];
    }
    return window.entryUrl;
  }
  // 公众号/普通 WebView：使用当前页面 URL，并去掉 '#' 及之后部分
  return window.location.href.split('#')[0];
}

/**
 * 初始化微信 JS-SDK
 * @param {Object} $http  Vue 实例的 $http
 * @param {Object} $API   接口地址集合（需包含 wechat_getSign）
 * @param {Array}  jsApiList 需要使用的 JSAPI 列表
 * @returns {Promise} 成功 resolve，失败 reject（可通过 catch 判断是否就绪）
 */
export function initWeChatSDK($http, $API, jsApiList = []) {
  if (isConfiguring && currentPromise) {
    return currentPromise;
  }

  isConfiguring = true;
  currentPromise = new Promise((resolve, reject) => {
    const url = getWechatSignUrl();
    const params = { url };

    $http.get($API.wechat_getSign, { params })
      .then(res => {
        const config = res.data;
        let configError = false;
        let readyTimer = null;

        const cleanup = () => {
          clearTimeout(readyTimer);
          isConfiguring = false;
          currentPromise = null;
        };

        wx.config({
          debug: false,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList
        });

        wx.ready(() => {
          readyTimer = setTimeout(() => {
            cleanup();
            if (!configError) {
              resolve();
            } else {
              reject(new Error('wx.config failed'));
            }
          }, 100);
        });

        wx.error((err) => {
          configError = true;
          cleanup();
          console.error('微信SDK配置失败', err);
          reject(err);
        });
      })
      .catch(err => {
        isConfiguring = false;
        currentPromise = null;
        console.error('获取微信签名失败', err);
        reject(err);
      });
  });

  return currentPromise;
}
